import YSlideshow from './Slideshow';

export { YSlideshow };
export default YSlideshow;
